import React from 'react'

export const ModalFooter: React.FC = ({ children }) => {
  return <div className="modal-footer">{children}</div>
}
